export default __webpack_public_path__ + "static/media/homepage-2.165601f9.webp";